import {defineSlotRecipe} from '@chakra-ui/react3'

export const campaignSlotRecipe = defineSlotRecipe({
    className: 'campaign',
    slots: [
        'moduleContainer',
        'flexContainer',
        'flexItemText',
        'flexItemImage',
        'copy',
        'buttonContainer',
        'headingCopyContainer'
    ],

    base: {
        moduleContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-40', s: 'spacing-80'}
        },
        flexContainer: {
            flexDirection: {base: 'column-reverse', s: 'row'},
            gap: {base: 'spacing-32', s: 'spacing-16'}
        },
        headingCopyContainer: {
            flexDirection: 'column',
            gap: 'spacing-16'
        },
        flexItemText: {
            flex: {s: '1 1 50%'},
            width: '100%',
            borderRadius: 's',
            flexDirection: 'column'
        },
        flexItemImage: {
            flex: {s: '1 1 50%'},
            width: {base: '100%'},
            borderRadius: 's',
            overflow: 'hidden'
        },
        buttonContainer: {
            paddingTop: {base: 'spacing-24', s: 'spacing-40'},
            gap: 'spacing-8',
            maxWidth: '100%',
            alignSelf: 'flex-start'
        }
    },

    variants: {
        imageAlignment: {
            right: {
                flexContainer: {
                    flexDirection: {base: 'column-reverse', s: 'row'}
                }
            },
            left: {
                flexContainer: {
                    flexDirection: {base: 'column-reverse', s: 'row-reverse'}
                },
                flexItemText: {
                    paddingLeft: {base: 'spacing-16', s: 'spacing-90'}
                }
            }
        },
        textBackground: {
            true: {
                flexContainer: {
                    gap: 'spacing-16'
                },
                flexItemText: {
                    backgroundColor: 'var(--module-surface-bg-color)',
                    paddingY: {base: 'spacing-40', s: 'spacing-90'},
                    paddingX: {base: 'spacing-16', s: 'spacing-90'}
                }
            },
            false: {
                flexItemText: {
                    backgroundColor: 'transparent'
                },
                headingCopyContainer: {
                    maxWidth: {s: '25.5625rem'}
                },
                buttonContainer: {
                    maxWidth: {s: '25.5625rem'},
                    width: {s: '25.5625rem'}
                }
            }
        },
        textAlignment: {
            center: {
                flexContainer: {
                    alignItems: {base: 'center', s: 'stretch'}
                },
                flexItemText: {
                    justifyContent: {s: 'center'}
                }
            },
            top: {
                flexContainer: {
                    alignItems: {base: 'start', s: 'stretch'}
                },
                flexItemText: {
                    justifyContent: {s: 'flex-start'}
                }
            }
        }
    },

    defaultVariants: {
        aspectRatio: '16/10',
        imageAlignment: 'right',
        textBackground: false,
        textAlignment: 'center'
    }
})
